import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  DialogActions,
  CircularProgress,
  Typography,
} from "@material-ui/core";

import Button from "../Button";
import { HaulageRecordDialogProps } from "../../../interface/dialog/HaulageRecordDialogProps";
import { Formik } from "formik";
import { GenerateReportFormSchema } from "../../reports/schema/generate-report-form-schema";
import FormDatePicker from "../form-date-picker";
import FormTextField from "../form-text-field";
import { GenerateHaulageRecordReportFormValues } from "../../../interface/formik/GenerateHaulageRecordReportFormValues";
import { useDialogStyles } from "./styles";

const HaulageRecordReportDialog = ({
  open,
  onClose,
  onSubmit,
}: HaulageRecordDialogProps) => {
  const classes = useDialogStyles();

  const generateReportFormValues: GenerateHaulageRecordReportFormValues = {
    fromDate: null,
    toDate: null,
    to: "",
    from: "",
    email: "",
  };

  return (
    <Dialog open={open} onClose={() => onClose()} fullWidth maxWidth="xs">
      <DialogTitle className={classes.dialogTitle}>
        {"Haulage Record Report"}
      </DialogTitle>
      <Formik
        initialValues={generateReportFormValues}
        onSubmit={(values, { setSubmitting }) =>
          onSubmit(values, setSubmitting)
        }
        validationSchema={GenerateReportFormSchema}
      >
        {({ values, handleSubmit, isSubmitting, setFieldValue }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent className={classes.dialogContent}>
              {isSubmitting ? (
                <Grid
                  container
                  direction="column"
                  alignItems="center"
                  spacing={2}
                  style={{ padding: "24px 0", textAlign: "center" }}
                >
                  <Grid item>
                    <CircularProgress />
                  </Grid>
                  <Grid item>
                    <Typography>Generating haulage records…</Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body2" color="textSecondary">
                      Large reports can take a minute or two. The records will be
                      emailed when ready — you can keep this open or close it.
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormTextField
                      name="from"
                      label="From Ticket Number"
                      value={values.from}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormTextField
                      name="to"
                      label="To Ticket Number"
                      value={values.to}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormDatePicker
                      label="From Date"
                      value={values.fromDate}
                      onChange={(date: any) => setFieldValue("fromDate", date)}
                      clearable
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormDatePicker
                      label="To Date"
                      value={values.toDate}
                      onChange={(date: any) => setFieldValue("toDate", date)}
                      clearable
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormTextField
                      name="email"
                      label="Email (defaults to your account email)"
                      value={values.email}
                    />
                  </Grid>
                </Grid>
              )}
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <div className={classes.actionButton}>
                <Button
                  label="Close"
                  color="default"
                  variant="contained"
                  type="button"
                  onClick={() => onClose()}
                />
              </div>
              <div className={classes.actionButton}>
                <Button
                  label={isSubmitting ? "Generating…" : "Generate"}
                  color="primary"
                  variant="contained"
                  type="submit"
                  disabled={isSubmitting}
                />
              </div>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
};

export default HaulageRecordReportDialog;
